import { render, staticRenderFns } from "./x-page-footer.vue?vue&type=template&id=7cb854ec"
import script from "./x-page-footer.vue?vue&type=script&lang=js"
export * from "./x-page-footer.vue?vue&type=script&lang=js"
import style0 from "./x-page-footer.vue?vue&type=style&index=0&id=7cb854ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports